import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {
    return {
	analysis: state.companies.analysis,
	selected_companies: state.companies.selected
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
	generate_analysis: (companies) => dispatch(stdAction(ACTIONS.companies.analysis, companies)),
    }
}

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View)

export default Container
